import View from './View'

const Container = ({ textCobranca }) => {
  return <View title="Dados Cobranca Single Contrato" textCobranca={textCobranca} />
}

export default Container
